import { type FC, useCallback } from "react";
import { useBooleanState } from "../../../../common/hooks/useBooleanState";
import { useDispatch } from "react-redux";
import { LinkButton } from "../../../../common/components/Link";
import ConfirmationModal from "../../../../common/components/ConfirmationModal";
import { resetConfiguratorAction } from "../../../Linear/redux/actions";
import { useTrackLCSimpleButtonClick } from "../../../Linear/hooks/useTrackLCClicks";
import { IconType } from "../../../../common/components/icon/IconType";
import { Icon } from "../../../../common/components/icon/Icon";
import { useTranslation } from "react-i18next";

const ResetLink: FC = () => {
  const { t } = useTranslation();
  const trackClick = useTrackLCSimpleButtonClick("click_on_reset");

  const { val: isModalVisible, setTrue: openModal, setFalse: closeModal } = useBooleanState(false);

  const dispatch = useDispatch();

  const submitCb = useCallback(() => {
    trackClick();
    dispatch(resetConfiguratorAction());
    closeModal();
  }, [closeModal, dispatch, trackClick]);

  return (
    <>
      <LinkButton iconBefore={<Icon type={IconType.Reset} />} onClick={openModal}>
        {t("page.linear.links.reset")}
      </LinkButton>

      {isModalVisible && (
        <ConfirmationModal
          onCancel={closeModal}
          onOk={submitCb}
          okLabel={t("page.linear.resetConfirmation.okButton")}
          cancelLabel={t("cancel")}
          label={t("page.linear.resetConfirmation.title")}
        />
      )}
    </>
  );
};
export default ResetLink;
